import { motion } from "motion/react";
import {
    Box,
    Button,
    Paper,
    TextField,
    Typography,
    InputAdornment,
} from "@mui/material";


import NumbersIcon from '@mui/icons-material/Numbers';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../toastify/config";
import apiRc from "../../axios/axios";
import LoadingSpinner from "../Spinner";
import { useNavigate } from "react-router-dom";

const LoginAhorrador = () => {


    const navigation = useNavigate()

    const [folioContrato, setFolioContrato] = useState('')
    const [cuatroDigitos, setCuatroDigitos] = useState('')
    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaValido, setCaptchaValido] = useState(false);
    const [isLoading, setIsLoading] = useState(false)

    const captchaRef = useRef(null);

    const onCaptchaChange = (token) => {
        setCaptchaToken(token);
        setCaptchaValido(!!token);
    };

    const entrar = () => {


        if (!folioContrato) return toast.error('Es necesario agregar el folio completo del contrato')
        if (!cuatroDigitos) return toast.error('Es necesario agregar los ultimos 4 digitos del celular registrado')

        if (!captchaValido) return toast.error('Es necesario seleccionar casilla');

        const iniciar = async () => {
            try {
                setIsLoading(true)
  
                const autenticarAhorrador = {
                    folio: folioContrato,
                    cel_digitos: cuatroDigitos,
                    captchaToken
                }

                const iniciarSesion = await apiRc.post('/ahorrador/iniciar-sesion', autenticarAhorrador, {
                    headers: {
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                sessionStorage.setItem("auth", crypto.randomUUID());

                sessionStorage.setItem("expira", (Date.now() + 20 * 60 * 1000).toString()); // 20 minutos

                sessionStorage.setItem("abonos", JSON.stringify(iniciarSesion.data.abonos));

                sessionStorage.setItem("rendimiento", iniciarSesion.data.rendimiento_anual);

                setIsLoading(false)


                navigation('/seguimiento-ahorro')

            } catch (error) {
                let msg_error = ''

                if (error.response) {

                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al obtener información, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }
        }

        iniciar()
    }

    return (
        <Box
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",

                backgroundImage: `linear-gradient(rgba(0,0,0,.45), rgba(0,0,0,.45)), url('/img/loginahorra.png')`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "cover",

                display: "flex",
                justifyContent: {
                    xs: "center",
                    md: "flex-end",
                },
                alignItems: "center",

                pr: {
                    xs: 2,
                    sm: 5,
                    md: "10%",
                    lg: "12%",
                },

                pl: 2,

                overflow: "hidden",
            }}
        >
            {isLoading ?
                <LoadingSpinner />
                : null}
            <motion.div
                initial={{
                    opacity: 0,
                    x: 80,
                    scale: 0.95,
                }}
                animate={{
                    opacity: 1,
                    x: 0,
                    scale: 1,
                }}
                transition={{
                    duration: 0.8,
                    easing: "ease-out",
                }}
            >
                <Paper
                    elevation={0}
                    sx={{
                        width: {
                            xs: "100%",
                            sm: 400,
                        },
                        p: 5,
                        borderRadius: 5,
                        backdropFilter: "blur(18px)",
                        background: "rgba(255,255,255,.12)",
                        border: "1px solid rgba(255,255,255,.18)",
                        color: "#FFF",
                    }}
                >
                    <Typography
                        variant="h4"
                        fontWeight="bold"
                        mb={1}
                    >
                        Bienvenido
                    </Typography>

                    <Typography
                        sx={{
                            color: "rgba(255,255,255,.75)",
                            mb: 4,
                        }}
                    >
                        Inicia sesión para continuar
                    </Typography>

                    <TextField
                        fullWidth
                        placeholder="Folio Contrato"
                        margin="normal"
                        variant="outlined"
                        onChange={(e) => setFolioContrato(e.target.value)}
                        value={folioContrato}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <NumbersIcon sx={{ color: "#FFF" }} />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                color: "#FFF",
                                borderRadius: 3,
                                background: "rgba(255,255,255,.08)",

                                "& fieldset": {
                                    borderColor: "rgba(255,255,255,.2)",
                                },

                                "&:hover fieldset": {
                                    borderColor: "#FFF",
                                },

                                "&.Mui-focused fieldset": {
                                    borderColor: "#FFF",
                                },

                                "& input::placeholder": {
                                    color: "rgba(255,255,255,.7)",
                                    opacity: 1,
                                },
                            },


                        }}
                    />

                    <TextField
                        fullWidth
                        type="password"
                        placeholder="Ultimos 4 digitos"
                        margin="normal"
                        variant="outlined"
                        onChange={(e) => setCuatroDigitos(e.target.value)}
                        value={cuatroDigitos}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SmartphoneIcon sx={{ color: "#FFF" }} />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                color: "#FFF",
                                borderRadius: 3,
                                background: "rgba(255,255,255,.08)",

                                "& fieldset": {
                                    borderColor: "rgba(255,255,255,.2)",
                                },

                                "&:hover fieldset": {
                                    borderColor: "#FFF",
                                },

                                "&.Mui-focused fieldset": {
                                    borderColor: "#FFF",
                                },
                                "& input::placeholder": {
                                    color: "rgba(255,255,255,.7)",
                                    opacity: 1,
                                },
                            },
                        }}
                    />

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            mt: 2,

                            "@media (max-width:400px)": {
                                transform: "scale(0.82)",
                                transformOrigin: "center",
                            },
                        }}
                    >
                        <ReCAPTCHA
                            ref={captchaRef}
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                            onChange={onCaptchaChange}
                        />
                    </Box>

                    <motion.div
                        whileHover={{
                            scale: 1.03,
                        }}
                        whileTap={{
                            scale: 0.97,
                        }}
                    >
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={entrar}
                            sx={{
                                mt: 4,
                                py: 1.5,
                                borderRadius: 3,
                                fontWeight: 700,
                                fontSize: 16,
                                background:
                                    "linear-gradient(135deg,#2EB872,#1B7F52)",

                                "&:hover": {
                                    background:
                                        "linear-gradient(135deg,#36C97D,#208E5B)",
                                },
                            }}
                        >
                            Iniciar sesión
                        </Button>
                    </motion.div>
                </Paper>
            </motion.div>

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </Box>
    );
};

export default LoginAhorrador;